import { Component } from '@angular/core';
import { IncomeService } from '../income.service';
import { Income } from '../income';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-income-edit',
  templateUrl: 'edit.component.html',
})
export class IncomeEditComponent {
  /**
   * Details of the income being edited.
   */
  public income: Income;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {IncomeService} incomeService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private incomeService: IncomeService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.incomeService.loading.subscribe(result => (this.isLoading = result));
    this.route.params.subscribe(params => this.loadIncome(params.id));
  }

  /**
   * Perform the edit action which send the edited income to the backend.
   */
  public edit() {
    const editIncome = this.incomeService
      .updateIncome(this.income.id, this.income)
      .subscribe(
        (result: Income) => {
          this.notificationService.success(
            `Income Updated`,
            `The income ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.income = new Income();
          editIncome.unsubscribe();
          this.router.navigate(['/incomes']);
        },
        err => {
          this.notificationService.error(
            `Income Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/incomes']);
        },
      );
  }

  /**
   * Loads the requested income so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadIncome(id: string) {
    this.incomeService.findIncome(id).subscribe(
      result => {
        this.income = result;
      },
      err => {
        this.notificationService.error(
          `Income Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/incomes']);
      },
    );
  }
}
